import React from 'react';
import './eventSelector.module.scss';
import { SheLocation } from '../../../types/location';
import { CheckBoxSelectInput, optionGenerator } from './CheckBoxSelectInput';
import {
  AttributeTags,
  CategoryTags,
  ATTRIBUTE_TAGS,
  CATEGORY_TAGS,
} from '../../organisms/events/states/EventListState';
import { getOptions, LocationFilter } from './LocationSelector';
import { ChevronRight } from '@material-ui/icons';
import classNames from 'classnames';

type Condition = {
  locations: LocationFilter[];
  categories: CategoryTags[];
  attributes: AttributeTags[];
};

type Props = {
  locations: SheLocation[];
  homeLocationId: number;
  showOnline?: boolean;
  showOnlineFirst?: boolean;
  showOther?: boolean;
  isHomeLocationSet: boolean;
  isOpen: boolean;
  condition: Condition;
  onChangeLocations: (values: LocationFilter[]) => void;
  onChangeCategories: (values: CategoryTags[]) => void;
  onChangeAttributes: (values: AttributeTags[]) => void;
  onToggle: () => void;
};

export const EventSelector = ({
  locations,
  homeLocationId,
  showOnline = true,
  showOnlineFirst = false,
  showOther = true,
  isHomeLocationSet,
  isOpen,
  condition,
  onChangeLocations,
  onChangeCategories,
  onChangeAttributes,
  onToggle,
}: Props) => {
  return (
    <section styleName="event-selector">
      <div styleName="selector-toggle" onClick={onToggle}>
        <span>会場やカテゴリで絞り込む</span>
        <ChevronRight styleName={classNames('chevron', isOpen ? '-up' : '-down')} />
      </div>
      {isOpen && (
        <div styleName="selector-body">
          <div styleName="label">会場</div>
          <CheckBoxSelectInput
            widthType="s"
            options={getOptions(locations, {
              showOnline,
              showOther,
              showOnlineFirst,
              homeLocationId,
              isHomeLocationSet,
            })}
            values={condition.locations}
            onChange={onChangeLocations}
            styleName="event-category-selector"
          />
          <div styleName="label">カテゴリ</div>
          <CheckBoxSelectInput
            widthType="s"
            options={optionGenerator(CATEGORY_TAGS)}
            values={condition.categories}
            onChange={onChangeCategories}
            styleName="event-category-selector"
          />
          <div styleName="label">こだわり条件</div>
          <CheckBoxSelectInput
            widthType="s"
            options={optionGenerator(ATTRIBUTE_TAGS)}
            values={condition.attributes}
            onChange={onChangeAttributes}
          />
        </div>
      )}
    </section>
  );
};
